module.exports = __webpack_public_path__ + "img/wishClose.54a3d862.png";